// Distribution.js
import React, { useEffect, useState, useCallback } from 'react';
import { API_BASE_URL } from '../config';
import './Distribution.css';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import RefreshButton from './RefreshButton';

ChartJS.register(ArcElement, Tooltip, Legend);

const INDEX_OPTIONS = [
  { label: 'NIFTY', value: 'NIFTY' },
  { label: 'BANKNIFTY', value: 'BANKNIFTY' },
  { label: 'FINNIFTY', value: 'FINNIFTY' },
  { label: 'MIDCPNIFTY', value: 'MIDCPNIFTY' },
];

const Distribution = () => {
  const [indexVal, setIndexVal] = useState('NIFTY');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [chartData, setChartData] = useState(null);

  const fetchData = useCallback(async (idx) => {
    setLoading(true);
    setError('');
    try {
      const url = `${API_BASE_URL}/api/pcr?index=${encodeURIComponent(idx)}`;
      const res = await fetch(url);
      const json = await res.json();

      if (!json.success) {
        throw new Error(json.message || 'Request failed');
      }

      const { total_call_oi, total_put_oi } = json.data;
      setChartData({
        labels: ['Total Call OI', 'Total Put OI'],
        datasets: [
          {
            label: `OI Distribution (${idx})`,
            data: [total_call_oi, total_put_oi],
            backgroundColor: ['#6366f1', '#10b981'],
            borderWidth: 2,
          },
        ],
      });
    } catch (e) {
      setChartData(null);
      setError(e.message || 'Error fetching data');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData(indexVal);
  }, [indexVal, fetchData]);

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'bottom' },
    },
  };

  return (
    <div className="distribution-container">
      <div className="search-bar">
        <select
          value={indexVal}
          onChange={(e) => setIndexVal(e.target.value)}
          className="index-select"
        >
          {INDEX_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>

        <RefreshButton 
          onRefresh={() => fetchData(indexVal)} 
          isLoading={loading}
          size="small"
        />
      </div>

      <h2 className="chart-title">Distribution</h2>

      {error && <p className="error-text">{error}</p>}
      {chartData ? (
        <Doughnut data={chartData} options={options} />
      ) : (
        !error && <p>Loading...</p>
      )}
    </div>
  );
};

export default Distribution;
